import { ComponentPropsWithoutRef } from 'react';
import BeyondPricingIcon from 'assets/images/icons/partners/beyondpricing.svg?react';
import DpgoIcon from 'assets/images/icons/partners/dpgo.svg?react';
import NightpricerIcon from 'assets/images/icons/partners/nighpricer.svg?react';
import PriceLabsIcon from 'assets/images/icons/partners/pricelabs.svg?react';
import QuibbleIcon from 'assets/images/icons/partners/quibble.svg?react';
import TurboSuiteIcon from 'assets/images/icons/partners/turbosuite.svg?react';
import WheelhouseIcon from 'assets/images/icons/partners/wheelhouse.svg?react';
import { Affiliate } from 'models/Integrations';

interface AffiliateIconProps extends ComponentPropsWithoutRef<'svg'> {
  affiliate: Affiliate;
}

const AffiliateIcon = ({ affiliate, ...props }: AffiliateIconProps) => {
  switch (affiliate) {
    case Affiliate.BEYONDPRICING:
      return <BeyondPricingIcon {...props} />;
    case Affiliate.DPGO:
      return <DpgoIcon {...props} />;
    case Affiliate.NIGHTPRICER:
      return <NightpricerIcon {...props} />;
    case Affiliate.PRICELABS:
      return <PriceLabsIcon {...props} />;
    case Affiliate.QUIBBLE:
      return <QuibbleIcon {...props} />;
    case Affiliate.TURBOSUITE:
      return <TurboSuiteIcon {...props} />;
    case Affiliate.WHEELHOUSE:
      return <WheelhouseIcon {...props} />;
    default:
      return null;
  }
};

export default AffiliateIcon;
